(function($) {
  $(window).on('load', () => {
    
    const header = document.querySelector('header');
    const distance = header.offsetTop;
  
    window.addEventListener('scroll', function (e) {
      let scrollPosition = window.scrollY;
      // if (+scrollPosition > 40) {
      //   if (!header.classList.contains('header--scrolled')) {
      //     header.classList.add('header--scrolled');
      //   }
      // } else {
      //   header.classList.remove('header--scrolled');
      // }

      if ( scrollPosition >= distance ) {
        if (!header.classList.contains('header--scrolled')) {
          header.classList.add('header--scrolled');
        }
      } else {
        header.classList.remove('header--scrolled');
      }
    });
  });

  var acc = document.getElementsByClassName("expand_section");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      var id = this.id;
      var target = document.getElementById(id+'-content');
      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + "px";
      }
    });
  }

})(jQuery);
